import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@cavo-admin/auth';

@Component({
	selector: 'cavo-admin-profile',
	imports: [AsyncPipe, DatePipe],
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent {
	private authService = inject(AuthService);

	user$ = this.authService.userProfile$;
}
